export const Svg = 'svg'
export const Path = 'path'
